import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/API/api.service';
import * as $ from 'jquery';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';

@Component({
  selector: 'app-listing-details',
  templateUrl: './listing-details.component.html',
  styleUrls: ['./listing-details.component.scss']
})
export class ListingDetailsComponent implements OnInit, AfterViewInit {

  productID: any
  productName = ''
  productDescription: any
  productImage = ''
  rate = 0
  vendorImage = ''
  vendorName = ''

  constructor(private api: ApiService, 
    private url: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private encrypt: EncryptionService) {}

  ngOnInit(): void {
    if(this.url.snapshot.params['productID']){
      this.productID = this.url.snapshot.params['productID'];
      this.productID = this.decodeHash(this.productID)
      this.productName = this.url.snapshot.params['productName']
      this.vendorImage = sessionStorage.getItem('categoryImage')
      this.vendorName = sessionStorage.getItem('vendorName')
      // console.log(this.vendorID)
    }

    if(this.productID){
      this.api.specificProduct(this.productID).subscribe({
        next: (response: any) => {
          this.productDescription = response.data.selectedProduct

          this.productImage = this.productDescription.avatar
          this.rate = this.productDescription.rate

          console.log(this.productDescription)
        }, error: (error: HttpErrorResponse) => {
          console.log(error)
        }
      })
    }
  }

  ngAfterViewInit(): void {
    // setTimeout(() => {
    //   console.log(this.productImage)
    //   $('.inner-bg2').css('background-image',`url(${this.productImage})`)
    //   $('.inner-bg2').css('background-position','center')
    //   $('.inner-bg2').css('background-size','contain')
    //   $('.inner-bg2').css('background-repeat','no-repeat')
    // }, 300);
  }

  decodeHash(hashedId: string): string | null {
    return this.encrypt.decryptionAES(hashedId);
  }

  generateHash(id: string): string {
    return this.encrypt.encryptionAES(id)
  }
}
